module.exports = __webpack_public_path__ + "static/media/policy.05145450.svg";